export default "__VITE_ASSET__33fd9ac2__"